import type { TUserRoles } from '../../app.constants';
import type { EmployeeData } from '../employee/emp-dashboard/emp-dashboard.type';

export type VerifiedUser = {
  id: string;
  email: string;
  phone: string;
  fullName: string;
  status: 'ACTIVE';
};

export type VerifyPayload = {
  access_token: string;
  user: VerifiedUser;
};

export type UserInfo = {
  userId: string;
  email: string;
};

// initial state for login
export interface AuthInitialState {
  theme: 'light' | 'dark';
  role?: TUserRoles;
  access_token?: string;
  userId?: string;
  verifiedInfo?: VerifiedUser;
  userInfo?: UserInfo;
  /** Set only for MULTI_ORG logins, sent as `X-Session-Id` on every request. */
  sessionId?: string;
  /** Employee `user_id` inside the selected organization (MULTI_ORG only). */
  sessionUserId?: string;
  selectedOrganization?: TOrganization;
  profileInfo?: EmployeeData;
  modulesInfo?: {
    moduleId: string;
    moduleName: string;
  }[];
  permissionsInfo: {
    access: string;
    module_id: string;
    module_name: string;
  }[];
}

export type TGetOtpVerify = {
  user: VerifiedUser;
  accessToken: string;
};

/* ------ Multi-organization login ------ */

export type TLoginBranch = 'EMPLOYEE' | 'MULTI_ORG' | 'INVALID';

export type TOrganization = {
  id: string;
  name: string;
  logo_url?: string | null;
};

export type TMyOrganizations = {
  branch: TLoginBranch;
  requiresOrganizationSelection?: boolean;
  organizations?: TOrganization[];
  code?: string;
};

export type TOrganizationSession = {
  session_id: string;
  organization_id: string;
  tenant_product_user_id: string;
  requires_session_header?: boolean;
  organization_name?: string;
  employee?: {
    name?: string;
    email?: string;
    employee_id?: string;
    photo?: string | null;
  };
};

export type TOrganizationSessionPayload = {
  sessionId?: string;
  userId?: string;
  organization?: TOrganization;
};

/** Backend error codes that mean the organization session must be picked again. */
export const ORGANIZATION_SESSION_ERRORS = [
  'ORGANIZATION_SELECTION_REQUIRED',
  'SESSION_INVALID',
  'SESSION_REVOKED',
] as const;
